import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDocument, PmsDocument } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDocument>
    useData={usePmsDocument}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
